<template>
  <div class="home">
    <AddHabbit />
    <ListHabbits />
  </div>
</template>

<script>
export default {
  components: {
    AddHabbit: () => import('@/components/AddHabbit'),
    ListHabbits: () => import('@/components/ListHabbits'),
  },
};
</script>
